import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  colors,
  Grid,
  IconButton,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';

import Title from 'components/typography/Title';

const useStyles = makeStyles({
  title: {
    flexGrow: 1,
    padding: 24,
  },
  exitButtonSpace: {
    padding: 8,
  },
  exitButton: {
    color: colors.red[900],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  acceptButton: {
    backgroundColor: colors.red[400],
    color: colors.grey[50],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const InputDialog = ({
  isOpened = false,
  closeDialog,
  title,
  inputValue,
  onInputChange,
  renderInput,
  validator,
  submitButtonLabel = '',
  onSubmit,
}) => {
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const classes = useStyles();

  const _validator = (value) => {
    if (validator) return validator(value);
    return null;
  };

  const _onInputChange = (value) => {
    onInputChange(value);
    if (showErrorMessage) setErrorMessage(_validator(value));
  };

  const _onSubmit = () => {
    setShowErrorMessage(true);

    const _errrorMessage = _validator(inputValue);

    if (!_errrorMessage) onSubmit();
    else setErrorMessage(_errrorMessage);
  };

  const _onClose = () => {
    setErrorMessage('');
    setShowErrorMessage(false);
    closeDialog();
  };

  return (
    <Dialog open={isOpened} fullWidth maxWidth="sm" onClose={_onClose}>
      <Grid container alignItems="flex-start">
        <Grid item className={classes.title}>
          <Title>{title}</Title>
        </Grid>
        <Grid item className={classes.exitButtonSpace}>
          <IconButton className={classes.exitButton} onClick={_onClose}>
            <Close></Close>
          </IconButton>
        </Grid>
      </Grid>

      <DialogContent>
        {renderInput(
          showErrorMessage ? errorMessage : '',
          _onInputChange,
          inputValue
        )}
      </DialogContent>
      <DialogActions style={{ paddingRight: 24, paddingBottom: 16 }}>
        <Button onClick={_onSubmit} className={classes.acceptButton}>
          <b>{submitButtonLabel}</b>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InputDialog;
